import { Theme } from "@mui/material";
import { OptionProps } from "@sis/react-library";
import { Property } from 'csstype';

export interface OptionWithColourProps extends OptionProps {
    colour?: Property.Color;
}

// Pricing Statuses
export const getPricingStatusOptions = (theme: Theme): OptionWithColourProps[] => {
    return [
        { value: 'AP', description: 'All Events Priced', colour: theme.palette.success.main },
        { value: 'PP', description: 'Partially Priced', colour: theme.palette.warning.main },
        { value: 'NP', description: 'No Events Priced', colour: theme.palette.error.main }
    ];
}

// Event Pricing Statuses
export const getEventPricingStatusOptions = (theme: Theme): OptionWithColourProps[] => {
    return [
        { value: 'P', description: 'Event Priced', colour: theme.palette.success.main },
        { value: 'N', description: 'Event Not Priced', colour: theme.palette.error.main }
    ];
}

// Pricing Phases
export const getPricingPhaseOptions = (theme: Theme): OptionWithColourProps[] => {
    return [
        { value: 'B', description: 'Board Prices', colour: theme.palette.success.main },
        { value: 'E', description: 'Early Prices', colour: theme.palette.warning.main },
        { value: 'I', description: 'Ignore', colour: theme.palette.error.main }
    ];
}

// Suspended Statuses
export const getSuspendedStatusOptions = (theme: Theme): OptionWithColourProps[] => {
    return [
        { value: 'U', description: 'Unsuspended', colour: theme.palette.success.main },
        { value: 'S', description: 'Suspended', colour: theme.palette.error.main }
    ];
}

// Derivative Statuses
export const getDerivativeStatusOptions = (theme: Theme): OptionWithColourProps[] => {
    return [
        { value: 'C', description: 'Created', colour: theme.palette.success.main },
        { value: 'N', description: 'Not Created', colour: theme.palette.error.main }
    ];
}
